const designatorsLLC = [
  'Ltd. Liability Company',
  'Limited Liability Co.',
  'Limited Liability Company',
  'Limited Company',
  'L.L.C.',
  'L. L. C.',
  'L L C.',
  'L L C',
  'L.L.L.C.',
  'L.C.',
  'L C',
  'LLLC',
  'LLC',
  'LC.',
  'LC',
  'Ltd. Company',
  'Ltd Co',
  'Ltd. Co',
  'Limited Co.',
  'Limited Liability Law Company',
  'Limited Liability Law Co.',
  'Professional Limited Liability Company',
  'PLLC',
  'P.L.L.C.',
  'low-profit limited liability company',
  'L3L',
] as const;

const designatorsInc = [
  'Inc.',
  'Corp.',
  'Incorporated',
  'Corporation',
  'Company',
  'Co.',
  'Limited',
  'Ltd.',
] as const;

export const removeEntityFromProductName = (productName: string | null) => {
  const entityTypes = [...designatorsLLC, ...designatorsInc];
  const entityTypePattern = new RegExp(
    `(,\\s)?\\b(?:${entityTypes.join('|')})$`,
    'gi',
  );

  return productName?.replace(entityTypePattern, '').trim() || '';
};
